// extracted by mini-css-extract-plugin
var _1 = "SywNQC5jAb M3_uvSqMlP";
var _2 = "O1Ggyz_kAt";
export { _1 as "alert", _2 as "message" }
